import { render, staticRenderFns } from "./RegistroActividad.vue?vue&type=template&id=64e5b0af&"
import script from "./RegistroActividad.vue?vue&type=script&lang=js&"
export * from "./RegistroActividad.vue?vue&type=script&lang=js&"
import style0 from "./RegistroActividad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports